<template>
  <div>
    <status-toggle-dialog
      :is-dialog-open="dialogAtivarOuInativarItem"
      :is-loading="loading"
      :title="titulo"
      :confirmation-message="`Tem certeza que deseja ${isEquipeAtivaMensagem} este item?`"
      :confirm="confirmarAtivacaoOuInativacaoItem"
      @update:isDialogOpen="v => dialogAtivarOuInativarItem = v"
    />

    <v-data-table
      colspan="100%"
      :headers="headers"
      :acesso-disable="acessoDisable"
      :items="items"
      :footer-props="{
        'items-per-page-text':'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
    >
      <template v-slot:no-data>
        Sem dados
      </template>
      <template #[`item.nome`]="{ item }">
        <router-link
          :to="{ name: 'equipe', params: { id: item.id } }"
          class="text--primary text-truncate cursor-pointer text-decoration-none"
        >
          <div class="d-flex align-center">
            <v-avatar
              :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
              size="32"
            >
              <span
                :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold
                `"
              >
                {{ item.nome.toUpperCase().charAt(0) }}{{ item.nome.toUpperCase().charAt(1) }}
              </span>
            </v-avatar>
            <div class="ms-3">
              <router-link
                :to="{ name: 'equipe', params: { id: item.id } }"
              ></router-link>
              {{ item.nome }}
            </div>
          </div>
        </router-link>
      </template>

      <template
        #[`item.descricao`]="{ item }"
      >
        <span class="text-capitalize">{{ item.descricao }}</span>
      </template>

      <template #[`item.ativo`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativo ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativo ? 'success' : 'secondary'}`"
        >
          {{ item.ativo ? 'Ativo' : 'Inativo' }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              color="primary"
              v-on="on"
            >
              <v-icon @click="ativarOuInativarItem(item)">
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </v-btn>
          </template>
          <v-list
            v-if="acessoDisable"
          >
            <v-list-item>
              <v-list-item-title
                role="button"
                class="d-flex"
                @click="openDialogAtivarOuInativarItem"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ isEquipeAtiva ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>
                <span class="text-capitalize">{{ isEquipeAtivaMensagem }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mdiCheckBold, mdiCloseThick, mdiDotsVertical } from '@mdi/js'
import { ref } from '@vue/composition-api'
import StatusToggleDialog from '@/components/dialog/StatusToggleDialog.vue'
import EquipeService from '@/services/modules/EquipeService'

export default {
  components: {
    StatusToggleDialog,
  },

  props: {
    items: {
      type: Array,
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => {},
    },
    acessoDisable: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, { emit }) {
    const dialogAtivarOuInativarItem = ref(false)
    const loading = ref(false)
    const equipeId = ref(0)
    const isEquipeAtiva = ref(undefined)
    const isEquipeAtivaMensagem = ref('')
    const titulo = ref('')

    const ativarOuInativarItem = item => {
      equipeId.value = item.id
      isEquipeAtiva.value = item.ativo
      isEquipeAtivaMensagem.value = item.ativo ? 'inativar' : 'ativar'
    }
    const openDialogAtivarOuInativarItem = () => {
      dialogAtivarOuInativarItem.value = true
      titulo.value = 'Ativar item'
    }
    const closeDialogAtivarOuInativarItem = () => {
      dialogAtivarOuInativarItem.value = false
      titulo.value = 'Inativar item'
    }
    const confirmarAtivacaoOuInativacaoItem = () => {
      loading.value = true

      EquipeService
        .confirmarAtivacaoOuInativacao(equipeId.value, { ativar: !isEquipeAtiva.value })
        .then(() => {
          emit('confirmar-inativacao')
        })
        .finally(() => {
          closeDialogAtivarOuInativarItem()
          loading.value = false
        })
    }

    return {
      dialogAtivarOuInativarItem,
      loading,
      isEquipeAtiva,
      isEquipeAtivaMensagem,
      titulo,
      ativarOuInativarItem,
      openDialogAtivarOuInativarItem,
      closeDialogAtivarOuInativarItem,
      confirmarAtivacaoOuInativacaoItem,
      icons: {
        mdiCheckBold,
        mdiCloseThick,
        mdiDotsVertical,
      },
    }
  },
}
</script>
